/**
 * HomeSLOrbHomeNumbersView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLOrbHomeNumbers
 */

import { useHomeSLOrbHomeNumbersLogic } from '@/hooks/traits/useHomeSLOrbHomeNumbersLogic';
import type { HomeSLOrbHomeNumbersConfig } from '@/hooks/traits/useHomeSLOrbHomeNumbersLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLOrbHomeView as HomeSLOrbHomeViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { SimpleGrid } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeSLOrbHomeNumbersViewProps {
  config?: Partial<HomeSLOrbHomeNumbersConfig>;
}

export function HomeSLOrbHomeNumbersView({ config: propsConfig }: HomeSLOrbHomeNumbersViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLOrbHomeNumbersLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLOrbHomeView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLOrbHomeNumbers">
      {slotWriter['main'] === 'INIT' ? (<Box paddingY="xl" bg={("muted" as 'transparent' | 'primary' | 'secondary' | 'muted' | 'accent' | 'surface' | 'overlay' | 'gradient' | 'inverse')} edgeTop="none" edgeBottom="none" edgeColor="background" texture={false} fullWidth={true}><Container size="xl" maxWidth="xl" padding="lg"><Stack direction="vertical" gap="lg"><Typography content={renderPatternValue(__t("std-orb-home:numbers.heading"))} variant="h3" weight="bold" align="center" className={((__t("std-orb-home:numbers.heading") === "")) ? "hidden" : "tracking-tight"} /><SimpleGrid cols={(Number(Math.min((Math.max((([{ label: __t("std-orb-home:numbers.targets"), value: "5" as const }, { label: __t("std-orb-home:numbers.stdlib"), value: "194" as const }, { label: __t("std-orb-home:numbers.languages"), value: "3" as const }, { label: __t("std-orb-home:numbers.warnings"), value: "0" as const }]).length), (1))), (4))) as 1 | 2 | 3 | 4 | 5 | 6)} gap="lg">{([{label: __t("std-orb-home:numbers.targets"), value: "5" as const}, {label: __t("std-orb-home:numbers.stdlib"), value: "194" as const}, {label: __t("std-orb-home:numbers.languages"), value: "3" as const}, {label: __t("std-orb-home:numbers.warnings"), value: "0" as const}]).map((item) => (<Stack direction="vertical" gap="xs" align="center"><Typography content={renderPatternValue((getNestedValue(item, "value") ?? ""))} variant="h2" weight="bold" align="center" className="tracking-tight text-primary" /><Typography content={renderPatternValue((getNestedValue(item, "label") ?? ""))} variant="body" color="muted" align="center" /></Stack>))}</SimpleGrid></Stack></Container></Box>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLOrbHomeNumbersView;
